/**
 * Split a string into substrings each whose UTF-8 encoding is at most `maxUtf8BytesPerSegment` long.
 * Each yielded piece is a valid substring (never splits a codepoint).
 */
export function* iterUtf8StringSegmentsByMaxBytes(
  text: string,
  maxUtf8BytesPerSegment: number,
): Generator<string, void, void> {
  if (maxUtf8BytesPerSegment < 1) {
    throw new Error("maxUtf8BytesPerSegment must be at least 1.");
  }
  const enc = new TextEncoder();
  let offset = 0;
  const len = text.length;
  while (offset < len) {
    let lo = offset + 1;
    let hi = len;
    let best = offset;
    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      const slice = text.slice(offset, mid);
      const n = enc.encode(slice).byteLength;
      if (n <= maxUtf8BytesPerSegment) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }
    if (best === offset) {
      throw new Error(
        "A single character exceeds the segment byte limit (try a smaller segment size or different content).",
      );
    }
    yield text.slice(offset, best);
    offset = best;
  }
}
